import { businessPath } from 'utils/businessRoutes'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Drawer, List, ListItem, ListItemText, ListItemAvatar } from '@mui/material'
import { CompanySelector, MenuItem } from 'components'
import {
  LocalOfferOutlined as OfferIcon,
  InfoOutlined as InfoIcon,
  Payment as PaymentIcon,
  Add as AddIcon,
  AssessmentOutlined as DashboardIcon,
  ReceiptOutlined as TransactionIcon,
} from '@mui/icons-material'
import { showBusinessForm } from 'modules/UI/actions'
import LogoSrc from 'components/Logo/Logo.png'
import { useParams } from 'react-router-dom';

const MobileMenu = ({
  isOpen,
  onClose,
  businesses
}) => {
  const dispatch = useDispatch()
  const userReadOnly = useSelector(state => state.user.details?.lifecycleStatus === 'SUSPENDED')
  const { businessId, organizationId } = useParams();
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
    >
      <Box p={2} pb={0}>
        <img src={LogoSrc} alt="" height={50} />
      </Box>
      {businesses &&
        <>
      <CompanySelector />
      <List sx={{ '& .MuiTypography-root': { color: 'black !important' } }} >
        <MenuItem disabled={!businesses} icon={<DashboardIcon sx={{ color: 'black' }}/>} text="Dashboard" link={businessPath(businessId, organizationId, 'dashboard') } />
        <MenuItem disabled={!businesses} icon={<OfferIcon sx={{ color: 'black' }}/>} text="Offers" link={businessPath(businessId, organizationId, 'offers')} />
        <MenuItem disabled={!businesses} icon={<TransactionIcon sx={{ color: 'black' }}/>} text="Transactions" link={businessPath(businessId, organizationId, 'transactions')} />
        <MenuItem disabled={!businesses} icon={<PaymentIcon sx={{ color: 'black' }}/>} text="Payments" link={businessPath(businessId, organizationId, 'payments')} />
        <MenuItem disabled={!businesses} icon={<InfoIcon sx={{ color: 'black' }}/>} text="Business profile" link={businessPath(businessId, organizationId, 'profile')} />
      </List>
      </>}
      <Box py={3}>
        <List>
          <ListItem button disabled={userReadOnly} onClick={() => {
            onClose()
            dispatch(showBusinessForm())
          }} style={{ background: '#eee' }}>
            <ListItemAvatar>
              <AddIcon />
            </ListItemAvatar>
            <ListItemText>
              Create new business
            </ListItemText>
          </ListItem>
        </List>
      </Box>

    </Drawer>
  )
}

export default MobileMenu
